import React, { useEffect, useState } from 'react';
import './LegalPage.scss';

export default function LegalPage({ url, title = 'Legal' }) {
  const [html, setHtml] = useState('');
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    let isMounted = true;
    setIsLoading(true);
    setError('');
    setHtml('');

    // Try fetching the remote HTML. If blocked by CORS, fall back to iframe rendering.
    fetch(url, { method: 'GET' })
      .then(async (res) => {
        if (!res.ok) throw new Error('Failed to load content');
        const text = await res.text();
        if (!isMounted) return;
        setHtml(text);
        setIsLoading(false);
      })
      .catch((e) => {
        if (!isMounted) return;
        setError(e.message || 'Unable to load content.');
        setIsLoading(false);
      });

    return () => { isMounted = false; };
  }, [url]);

  return (
    <div className="legal-page">
      <div className="legal-container">
        <h2 className="legal-title">{title}</h2>
        {isLoading && (
          <div className="legal-loading">
            <div className="spinner" />
            <span>Loading…</span>
          </div>
        )}
        {!isLoading && html && (
          <article className="legal-content" dangerouslySetInnerHTML={{ __html: html }} />
        )}
        {!isLoading && !html && (
          <div className="legal-fallback">
            <p className="legal-error">{error || 'Unable to display content directly. Showing embedded page instead.'}</p>
            <iframe title={title} src={url} className="legal-iframe" />
          </div>
        )}
      </div>
    </div>
  );
}


